export enum ItemType {
  ITEM = "ITEM",
  SERVICE = "SERVICE",
  PRODUCT = "PRODUCT",
  PACKAGE = "PACKAGE",
  MEMBERSHIP = "MEMBERSHIP",
  MEDICATION = "MEDICATION",
  SERVICE_FEE = "SERVICE_FEE",
  GIFT_CARD = "GIFT_CARD",
}
